import styled from "styled-components";

export const MainContainer = styled.section`
display: ${props => props.display ? props.display : 'none'};
padding: 0px 0px var(--40px,40px) 0px;
flex-direction: column;
-webkit-box-pack: end;
justify-content: flex-end;
position: absolute;
align-items: flex-start;

@media screen and (min-width: 425px) {
  width: fit-content;
  left: 0;
  bottom: 0;
  padding: 0px 0px var(--40px,40px) var(--40px,40px);
}
@media screen and (max-width: 426px) {
  width: 100%;
  bottom: 0px;
  border-radius: 33px;
  padding: 16px;
}
`;

export const SnackContainer = styled.section`
  display: flex;
  flex-direction: row;
  padding: var(--16px,16px);
  -webkit-box-align: center;
  align-items: center;
  gap: var(--16px,16px);
  border-radius: var(--12px,12px);
  background: rgba(66, 134, 0, 0.8);
  width: 100%;
  justify-content: space-between;
`;

export const SnackContent = styled.section`
display: flex;
flex-direction: column;
`;

export const ParagraphWhite = styled.span`
  color: var(--greyscale-discontinue-use-white, #FFF);
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

